import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { createProduct } from "../../actions/productAction";
import Axios from "../../axios/axios";
import {
  ListCategories,
  ListCategorieswithoutpagination,
} from "../../actions/categoryAction";
import Stock from "./Stock";

export default function EditProduct() {
  const { id } = useParams();

  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [photo1, setPhoto1] = useState("");
  const [photo2, setPhoto2] = useState("");
  const [photo3, setPhoto3] = useState("");
  const [brand, setBrand] = useState("");
  const [price, setPrice] = useState("");
  const [offerPrice, setOfferPrice] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [purchaseDate, setPurchaseDate] = useState("");
  const [service, setService] = useState("");
  const [warrantyType, setWarrantyType] = useState();
  const [productType, setProductType] = useState(false);
  const [billUpload, setBillUpload] = useState("");
  const [stock, setStock] = useState([
    {
      stock: 0,
      itemCode: "",
    },
  ]);

  const [brandList, setBrandList] = useState([]);
  console.log(brandList);

  const catList = useSelector((state) => state.catList);
  const { loading, error, categories } = catList;

  useEffect(() => {
    dispatch(ListCategorieswithoutpagination(""));

    getProduct();
    getBrands();
  }, [dispatch]);

  const getBrands = async () => {
    let data = await Axios.get("/api/brand?pageSize=1000&pageNumber=1");
    setBrandList(data.data.brands);
  };

  console.log(brand);
  console.log(categories);

  const getProduct = async () => {
    const { data } = await Axios.get(`/api/products/${id}`);
    console.log(data);

    setName(data?.name);
    setDescription(data?.description);
    setCategory(data?.category?._id);
    setPhoto1(data?.image1);
    setPhoto2(data?.image2);
    setPhoto3(data?.image3);
    setBrand(data?.brand?._id);
    setPrice(data?.price);
    setOfferPrice(data?.offerPrice);
    setItemCode(data?.itemCode);
    setStock(data?.stock);
    setPurchaseDate(data?.purchaseDate);
    setWarrantyType(data?.warrantyType);
    setProductType(data?.productType);
    setService(data?.service);
    setBillUpload(data?.billUpload);
  };
  console.log(brand);
  console.log(photo1, photo2, photo3);

  const submitHandler = async (e) => {
    e.preventDefault();

    let data = {
      name,
      description,
      category,
      image1: photo1,
      image2: photo2,
      image3: photo3,
      brand,
      price,
      offerPrice,
      // itemCode,
      stock,
      purchaseDate,
      warrantyType,
      productType,
      service,
      billUpload,
    };

    let response = await Axios.put(`/api/products/${id}`, data);
    console.log(response);
    if (response.status === 200) {
      window.location.href = "/products";
    }
    //
  };

  const uploadFileHandler = async (e, val) => {
    console.log("uploading");
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await Axios.post("/api/upload", formData, config);

      if (val === "photo1") {
        setPhoto1(data);
      } else if (val === "photo2") {
        setPhoto2(data);
      } else if (val === "billupload") {
        setBillUpload(data);
      } else if (val === "photo3") {
        setPhoto3(data);
      }
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  let stockDiv = stock.map((data, index) => {
    return (
      <Stock
        index={index}
        setStock={setStock}
        stock={stock}
        product={{ name, brand, category, price, offerPrice, productType }}
        brandList={brandList}
        categories={categories}
      />
    );
  });

  const addStock = () => {
    let obj = {
      stock: 0,
      itemCode: "",
    };

    setStock([...stock, obj]);
  };

  return (
    <div className="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Edit Product</h4>
            <form class="forms-sample" onSubmit={submitHandler}>
              <div class="form-group">
                <label for="exampleInputName">Product Name</label>
                <input
                  type="text"
                  class="form-control"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="name"
                  value={name}
                  required={true}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputName">Description</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Category</label>
                <select
                  className="form-control"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  required={true}
                >
                  <option>Select Category</option>
                  {categories?.map((data) => (
                    <option value={data?._id}>{data?.categoryName}</option>
                  ))}
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Photo 1</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "photo1")}
                />
              </div>
              <img
                src={
                  photo1 === ""
                    ? process.env.PUBLIC_URL + "/images/select_image.png"
                    : `${photo1}`
                }
                height="100"
              />
              <div class="form-group">
                <label for="exampleInputPriority4">Photo 2</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "photo2")}
                />
              </div>
              <img
                src={
                  photo2 === ""
                    ? process.env.PUBLIC_URL + "/images/select_image.png"
                    : `${photo2}`
                }
                height="100"
              />
              <div class="form-group">
                <label for="exampleInputPriority4">Photo 3</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "photo3")}
                />
              </div>
              <img
                src={
                  photo3 === ""
                    ? process.env.PUBLIC_URL + "/images/select_image.png"
                    : `${photo3}`
                }
                height="100"
              />{" "}
              <div class="form-group">
                <label for="exampleInputName">Brand</label>
                <div class="form-group">
                  <label for="exampleInputName">Brand</label>
                  <select
                    onChange={(e) => setBrand(e.target.value)}
                    className="form-control"
                    value={brand}
                  >
                    <option value="">Select Brand</option>
                    {brandList?.map((data) => (
                      <option value={data._id}>{data?.brandName}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label for="exampleInputName">Price</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Price"
                  value={price}
                  required={true}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Bill Upload</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "billupload")}
                />
              </div>
              <img
                src={
                  billUpload === ""
                    ? process.env.PUBLIC_URL + "/images/select_image.png"
                    : `${billUpload}`
                }
                height="100"
              />{" "}
              <div class="form-group">
                <label for="exampleInputName">Purchase Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="Offer Price"
                  value={purchaseDate}
                  onChange={(e) => setPurchaseDate(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputName">Warranty Type</label>
                <select
                  className="form-control"
                  value={warrantyType}
                  onChange={(e) => setWarrantyType(e.target.value)}
                >
                  <option disabled>Select Warranty Type</option>

                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputName">Product Type </label>
                <select
                  className="form-control"
                  value={productType}
                  onChange={(e) => setProductType(e.target.value)}
                >
                  <option disabled>Select Product Type</option>

                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputName">Service</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="productType"
                  value={service}
                  onChange={(e) => setService(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputName">Offer Price</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Offer Price"
                  value={offerPrice}
                  onChange={(e) => setOfferPrice(e.target.value)}
                />
              </div>
              <hr />
              {stockDiv}
              <div class="d-flex">
                <div class="p-2"> </div>
                <div class="p-2"> </div>
                <div class="ml-auto p-2 pointer" onClick={addStock}>
                  + Add more
                </div>
              </div>
              <button type="submit" class="btn btn-primary mr-2">
                Submit
              </button>
              <Link to="/products">
                <button class="btn btn-light">Cancel</button>
              </Link>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
